<template>
  <div class="popup-content-body">
    <el-button
      v-for="(button, buttonIndex) in buttonList" 
      :key="buttonIndex" 
      :type="button.type"
      :loading="loadingState[button['loading']]"
      size="mini"
      @click="button.fun(marker)">{{ button.name }}</el-button>
  </div>
</template>

<script>
export default {
  // 组件数据
  props: {
    buttonList: {
      type: Array,
      default() {
        return [];
      },
    },
    marker: {
      type: Object,
      default() {
        return {};
      }
    },
    loadingState: {
      type: Object,
      default() {
        return {};
      }
    }
  },

  data() {
    return {

    };
  },
  // 组件启动时
  created() { },
  // 组件启动后
  mounted() { 
  },
  computed: {},
  watch: {},
  // 方法块
  methods: {
  },
  // 组件销毁时
  destroyed() {
  }
}
</script>

<style scoped lang="less">
  .popup-content-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 5px;
    width: 90px;
    height: auto;
    padding: 10px 0;
    .el-button {
      margin-left: 0;
    }
  }
</style>
